import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthDrawer } from '../context/AuthDrawerContext';

const FOOTER_CSS = `
  .ck-footer {
    background: #0f172a;
    color: #cbd5e1;
    padding: 3rem 2rem 2rem;
    font-family: 'Inter', sans-serif;
  }
  .ck-footer-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    gap: 2.5rem;
  }
  .ck-footer-brand-col h3 {
    font-family: 'Syne', sans-serif;
    font-weight: 800;
    font-size: 1.15rem;
    color: white;
    margin-bottom: 0.5rem;
    letter-spacing: -0.03em;
  }
  .ck-footer-brand-col p {
    font-size: 0.85rem;
    line-height: 1.6;
    color: #94a3b8;
    max-width: 280px;
  }
  .ck-footer-col h4 {
    font-size: 0.75rem;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 0.85rem;
  }
  .ck-footer-col ul {
    list-style: none; padding: 0; margin: 0;
    display: flex; flex-direction: column; gap: 0.55rem;
  }
  .ck-footer-col a,
  .ck-footer-col button.linklike {
    color: #cbd5e1;
    text-decoration: none;
    font-size: 0.88rem;
    transition: color 0.15s;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
  }
  .ck-footer-col a:hover,
  .ck-footer-col button.linklike:hover { color: white; }

  .ck-footer-bottom {
    max-width: 1280px;
    margin: 2.5rem auto 0;
    padding-top: 1.5rem;
    border-top: 1px solid #1e293b;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }
  .ck-footer-copy {
    font-size: 0.8rem;
    color: #94a3b8;
  }
  .ck-footer-made {
    font-size: 0.8rem;
    color: #94a3b8;
  }
  .ck-footer-made strong { color: #fbbf24; }

  @media (max-width: 768px) {
    .ck-footer { padding: 2.5rem 1.25rem 1.5rem; }
    .ck-footer-inner { grid-template-columns: 1fr 1fr; gap: 2rem; }
    .ck-footer-brand-col { grid-column: 1 / -1; }
    .ck-footer-bottom { flex-direction: column; align-items: flex-start; }
  }
`;

export default function Footer() {
  const year = new Date().getFullYear();
  const { openSignIn, openSignUp } = useAuthDrawer();
  return (
    <>
      <style>{FOOTER_CSS}</style>
      <footer className="ck-footer">
        <div className="ck-footer-inner">
          <div className="ck-footer-brand-col">
            <h3>🎬 CreatorKhata</h3>
            <p>The all-in-one business app for Indian creators — from brand pitch to paid invoice, in one workflow.</p>
          </div>

          <div className="ck-footer-col">
            <h4>Product</h4>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="/blog">Blog</a></li>
              <li><button type="button" className="linklike" onClick={openSignIn}>Sign In</button></li>
              <li><button type="button" className="linklike" onClick={openSignUp}>Get Started</button></li>
            </ul>
          </div>

          <div className="ck-footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
              <li><Link to="/cancellation">Cancellation</Link></li>
            </ul>
          </div>

          <div className="ck-footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="ck-footer-bottom">
          <div className="ck-footer-copy">© {year} CreatorKhata. All rights reserved.</div>
          <div className="ck-footer-made">Made for Indian creators <strong>🇮🇳</strong></div>
        </div>
      </footer>
    </>
  );
}
